<template>
  <base-content>
    <template v-slot:top>
      <hero-header :heading="`Edit Investment #${$route.params.id}`">
        <base-button exact icon-left="arrow-left" :to="{ name: 'investments' }">
          Investments
        </base-button>
        <base-button class="mx-2" :loading="isDownloadBatchPaymentTemplatePending" @click="downloadTemplate">
          Download Payment Template
        </base-button>
        <base-button class="mr-2" :loading="isDownloadTransactionsPending" @click="downloadTransactionHistory">
          Download Transactions
        </base-button>
        <base-button secondary @click="exportInvestors">
          Export Investors
        </base-button>
      </hero-header>
    </template>

    <template v-if="ready">
      <ul class="nav nav-pills nav-fill bg-light mb-4">
        <li class="nav-item">
          <router-link class="nav-link" exact :to="{ name: 'investments.edit', params: { id: edit } }">
            Listing
          </router-link>
        </li>
        <li class="nav-item" v-for="(text, name) in links" :key="name">
          <router-link class="nav-link" exact :to="{ name: `investments.edit.${name}`, params: { id: edit } }">
            {{ text }}
          </router-link>
        </li>
      </ul>

      <investment-editor v-if="ready && active === 'listing'" />

      <template>
        <investment-documents v-if="active === 'documents'" @refresh="refresh" />
        <investment-media v-if="active === 'media'" @refresh="refresh" />
        <investment-funding-rounds v-if="active === 'funding-rounds'" @refresh="refresh" />
        <template v-if="active === 'investors'">
          <investment-investors />
          <investment-transfers />
        </template>
        <investment-shares v-if="active === 'shares'" @refresh="refresh" />
        <investment-statement v-if="active === 'statement'" @refresh="refresh" />
        <investment-audit v-if="active === 'audit'" @refresh="refresh" />
        <investment-tools v-if="active === 'tools'" @refresh="refresh" />
      </template>
    </template>
    <template v-else>
      <base-loader />
    </template>
  </base-content>
</template>

<script>
import { mapActions, mapState } from 'vuex'

import HeroHeader from '@/components/HeroHeader.vue'
import InvestmentAudit from '@/components/InvestmentAudit.vue'
import InvestmentDocuments from '@/components/InvestmentDocuments.vue'
import InvestmentEditor from '@/components/InvestmentEditor.vue'
import InvestmentFundingRounds from '@/components/InvestmentFundingRounds.vue'
import InvestmentInvestors from '@/components/InvestmentInvestors.vue'
import InvestmentMedia from '@/components/InvestmentMedia.vue'
import InvestmentShares from '@/components/InvestmentShares.vue'
import InvestmentStatement from '@/components/InvestmentStatement.vue'
import InvestmentTools from '@/components/InvestmentTools.vue'
import InvestmentTransfers from '@/components/InvestmentTransfers.vue'

export default {
  components: {
    HeroHeader,
    InvestmentAudit,
    InvestmentDocuments,
    InvestmentEditor,
    InvestmentFundingRounds,
    InvestmentInvestors,
    InvestmentMedia,
    InvestmentShares,
    InvestmentStatement,
    InvestmentTools,
    InvestmentTransfers
  },

  data: () => ({
    active: '',
    edit: null,
    links: {
      documents: 'Documents',
      media: 'Media',
      'funding-rounds': 'Funding Rounds',
      investors: 'Investors',
      shares: 'Shares',
      statement: 'Statement',
      audit: 'Audit',
      tools: 'Tools'
    },
    ready: false
  }),

  computed: {
    ...mapState({
      investment: store => store.core.investments.entity,
      isDownloadBatchPaymentTemplatePending: store => store.core.investments.isDownloadBatchPaymentTemplatePending,
      isDownloadTransactionsPending: store => store.core.investments.isDownloadTransactionsPending
    })
  },

  created () {
    this.refresh()
    this.setActiveTab()
  },

  methods: {
    async downloadTemplate () {
      const template = await this.downloadBatchPaymentTemplate({
        investment: this.investment._id
      })

      window.location = this.$document.path(template)
    },

    async downloadTransactionHistory () {
      const template = await this.downloadTransactions({
        investment: this.investment._id
      })

      window.location = this.$document.path(template)
    },

    exportInvestors () {
      this.exportInvestorsAsCsv({ investment: this.$route.params.id })
        .then(document => {
          window.location = this.$document.path(document)
        })
        .catch(err => this.$flash.failure(err))
    },

    refresh () {
      const { id } = this.$route.params

      this.getInvestment(id)
        .then(() => {
          this.edit = id
          this.ready = true
        })
        .catch(err => {
          this.$flash.failure(err)
          this.$router.push({ name: 'investments' })
        })
    },

    setActiveTab () {
      const { tab } = this.$route.meta

      this.active = tab || 'listing'
    },

    ...mapActions({
      downloadBatchPaymentTemplate: 'core/investments/download-batch-payment-template',
      downloadTransactions: 'core/investments/download-transactions',
      exportInvestorsAsCsv: 'core/investments/export-investors-as-csv',
      getInvestment: 'core/investments/get'
    })
  },

  watch: {
    $route: {
      deep: true,
      handler () {
        this.setActiveTab()
      }
    }
  }
}
</script>
